import React, { FunctionComponent } from 'react'

interface IOptional {
    show: boolean
}

export const Optional: FunctionComponent<IOptional> = ({ show, children }) => {
    return show ? <> {children} </> : null
}
